import buildBasePayload from './buildBasePayload.js';

const calculateType2CopyModelPostPayload = (baseModel, createdById, orgId, permissions) => {
  const { uploadedStructuralResponses, uploadedGroundMotionId, uploadedModeShapeId } = baseModel;
  return {
    ...buildBasePayload(baseModel, createdById, orgId, permissions),
    uploadedStructuralResponses,
    uploadedGroundMotionId,
    uploadedModeShapeId,
  };
};

export default calculateType2CopyModelPostPayload;
